module.exports = __webpack_public_path__ + "static/media/list.f9c7c451.svg";